export const PlayerManager = {
    currentDimension: "main",
    physics: {},
    stats: {},
    $INIt(data) { },
};
